import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {User} from "../../../../../../../user/user";
import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionType
} from "../../../../../../../user/user-subscription";
import AllPlansFeatures from "./allPlansFeatures.json";
import addOnsFeatures from './addOnsFeatures.json';
import SecondaryFeatures from './secondaryFeatures.json';
import {filter, first} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../../../store";
import {CookieService} from "ngx-cookie";
import {CountPipe} from "../../../../../../../shared/pipes/count.pipe";
import {SizePipe} from "../../../../../../../shared/pipes/size.pipe";
import {ChosenPlan} from "../../../../../payment-info/models/plan.model";
import {
  CopilotVideoComponent
} from "../../../../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/copilot-video/copilot-video.component";
import {DbModalService} from "../../../../../../../modules/modal/modal";
import {GoogleAnalyticsService} from "../../../../../../../shared/services/google-analytics/google-analytics.service";
import {DbResponse} from "../../../../../../../shared/interceptors/db-response";
import {AuthService} from "../../../../../../../auth/auth.service";
import {DialogService} from "../../../../../../../../ng2-bootstrap-modal/dialog.service";
import {SwitchAnnualDialogComponent} from "../../../../../../../workspace/subscription-plan/alernative-subscription-plan/ds-billing-info/switch-annual-dialog/switch-annual-dialog.component";
import {UserSubscriptionStatus} from "../../../../../../../user/user-subscription-status";
import {Config} from "../../../../../../../config/config";
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-agency-plans',
    templateUrl: './agency-plans.component.html',
    styleUrls: ['./agency-plans.component.scss'],
    standalone: false
})
export class AgencyPlansComponent implements OnInit, OnChanges {

  @Input() higherPlan: boolean = false;
  @Input() user: User;
  @Input() currentSubscription: UserSubscription;
  @Input() couponPercent: number;
  @Input() couponDays: number;
  @Input() annualPrice: number;
  @Input() periodSwitch: number = 12;
  @Input() subscriptions: UserSubscription[] = [];
  @Input() allAvailableSubscriptions: UserSubscription[] = [];
  @Input() shouldStackPlans: boolean = false;
  @Input() canSwitch: boolean;
  @Input() showSwitchAnnual: boolean;
  @Input() invitedUser: boolean;
  @Output() onBack = new EventEmitter<string>();
  @Output() onPlanSelect = new EventEmitter<ChosenPlan>();
  @Output() onVMSelect = new EventEmitter<any>();
  @Output() onPaidSelect = new EventEmitter<any>();

  chosenPlan: ChosenPlan;
  couponCode: string;
  expirationDate: string;
  allPlansFeatures: any = AllPlansFeatures;
  secondaryFeatures: any = SecondaryFeatures;
  addOnsFeatures = addOnsFeatures;
  userSubscriptionStatus: typeof UserSubscriptionStatus = UserSubscriptionStatus;
  UserSubscriptionCategory = UserSubscriptionCategory;
  UserSubscriptionType = UserSubscriptionType;
  planTypeInfo: any[];
  counts = ['100', '400', '1K'];
  selectedCount = '100';
  selectedLocation = "Council Bluffs, Iowa, USA";
  isDropdownOpen = false;
  isTier1Country: boolean;
  dataCenterLocations = [
    "Council Bluffs, Iowa, USA",
    "Moncks Corner, South Carolina, USA",
    "Ashburn, Northern Virginia, USA",
    "The Dalles, Oregon, USA",
    "Los Angeles, California, USA",
    "St. Ghislain, Belgium",
    "London, England, UK",
    "Frankfurt, Germany",
    "Eemshaven, Netherlands",
    "Changhua County, Taiwan",
    "Mumbai, India",
    "Sydney, Australia"
  ];
  applyCouponForPlatform = false;
  hasFreeDays: boolean = false;
  userHostingSubscriptions: UserSubscription[];
  upgradeableEnterpriseSubscription: UserSubscription;

  constructor(
    private readonly _activeModal: DbActiveModal,
    private _store: Store<fromStore.DbStoreState>,
    private _authService: AuthService,
    private _cookieService: CookieService,
    private _modalService: DbModalService,
    private eRef: ElementRef,
    private _dialogService: DialogService,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
    const getExperimentalCookie = this._cookieService.get('db-experiment');

    this.isTier1Country = getExperimentalCookie ?
      JSON.parse(getExperimentalCookie) && JSON.parse(getExperimentalCookie).t1PExp && JSON.parse(getExperimentalCookie).t1PExp === 'b' : false;

    this.userHostingSubscriptions = this.allAvailableSubscriptions;

    const defaultWebsiteCount = '100';
    const defaultZone = 'Council Bluffs, Iowa, USA';

    let selectedWebsiteCount = this.selectedCount || defaultWebsiteCount;
    let selectedZone = this.selectedLocation || defaultZone;

    this.upgradeableEnterpriseSubscription = this.getMatchingEnterpriseSubscription(
      this.userHostingSubscriptions,
      selectedWebsiteCount,
      selectedZone,
      this.periodSwitch
    );

    if (!this.upgradeableEnterpriseSubscription) {
      this.upgradeableEnterpriseSubscription = this.getMatchingEnterpriseSubscription(
        this.userHostingSubscriptions,
        defaultWebsiteCount,
        defaultZone,
        this.periodSwitch
      );
    }

    if (this.upgradeableEnterpriseSubscription && this.subscriptions.length >= 3) {
      this.subscriptions[2] = this.upgradeableEnterpriseSubscription;
    }

    this.processSecondaryFeatures();
    this.processAddOnsFeatures();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['periodSwitch'] && !changes['periodSwitch'].firstChange) {
      this.updateEnterpriseSubscription();
    }

    if (changes['subscriptions'] && !changes['subscriptions'].firstChange) {
      if (this.userHostingSubscriptions && this.userHostingSubscriptions.length) {
        this.updateEnterpriseSubscription();
      }
    }

    if (changes['allAvailableSubscriptions'] && !changes['allAvailableSubscriptions'].firstChange) {
      this.userHostingSubscriptions = this.allAvailableSubscriptions;
      if (this.userHostingSubscriptions && this.userHostingSubscriptions.length) {
        this.updateEnterpriseSubscription();
      }
    }
  }

  selectCount(count: string): void {
    this.selectedCount = count;
    this.updateEnterpriseSubscription();
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectLocation(location: string): void {
    this.selectedLocation = location;
    this.isDropdownOpen = false;
    this.updateEnterpriseSubscription();
  }

  chooseSubscription(plan: UserSubscription): void {
    this.chosenPlan = {
      id: plan.id,
      title: plan.plan.title,
      price: plan.plan.planPrice,
      planId: plan.plan.planId,
      coupleId: plan?.coupleId || (plan.plan?.couplePlanId).toString(),
      tabCategory: plan?.plan?.shortFeatures?.tabCategory,
      category: plan?.type,
      type: this.periodSwitch === 12 ? 'year' : 'month',
      periodNumber: plan.plan.periodNumber,
      services: plan?.plan?.services
    };

    if (this.chosenPlan?.category === UserSubscriptionCategory.DedicatedVM) {
      const monthlySubscription = this.getMatchingEnterpriseSubscription(
        this.userHostingSubscriptions,
        this.selectedCount, // '100' (4 processors)
        this.selectedLocation, // 'Council Bluffs, Iowa, USA'
        1
      );

      const annuallySubscription = this.getMatchingEnterpriseSubscription(
        this.userHostingSubscriptions,
        this.selectedCount, // '100' (4 processors)
        this.selectedLocation, // 'Council Bluffs, Iowa, USA'
        12
      );
      const monthlyCouplePlan: ChosenPlan = {
        id: monthlySubscription?.id,
        title: 'Agency Ultimate',
        price: monthlySubscription?.plan?.planPrice,
        type: 'month',
        coupon: monthlySubscription?.couponCode,
        periodNumber: monthlySubscription?.periodNumber,
      };
      const annuallyCouplePlan: ChosenPlan = {
        id: annuallySubscription.id,
        title: 'Agency Ultimate',
        price: annuallySubscription?.plan?.planPrice,
        type: 'year',
        coupon: annuallySubscription?.couponCode,
        periodNumber: annuallySubscription?.periodNumber,
      };

      this.chosenPlan.monthlyPlan = monthlyCouplePlan;
      this.chosenPlan.annuallyPlan = annuallyCouplePlan;
    }

    const date = new Date();
    date.setDate(date.getDate() + 7);
    this.expirationDate = date.toDateString();
    if (this.currentSubscription?.platformPaidClient) {
      if (this.chosenPlan?.category === UserSubscriptionCategory.DedicatedVM) {
        this.showTalkToSalesDialog();
      } else {
        this.onPaidSelect.emit(plan);
      }
    } else {
      this.onPlanSelect.emit(this.chosenPlan);
    }
  }

  showTalkToSalesDialog(): void {
    this._activeModal.close();
  }

  openVideoPopup(): void {
    this._modalService.open(CopilotVideoComponent, {
      height: 563, width: 1000, hasOutsideRightCloseBtn: true,
      hasCloseBtn: false, backdrop: 'static'
    });
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  public _sendEvent(label?): void {
    const analyticsData = {
      eventCategory: "Free Upgrade Offer",
      eventAction: "Change Subscription",
      eventLabel: label || "VPS Plan Edit",
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  isCurrentPlan(plan: UserSubscription): boolean {
    if (!this.currentSubscription || !plan) {
      return false;
    }

    if (this.currentSubscription.id === plan.id ||
      this.currentSubscription.subscriptionId === plan.subscriptionId) {
      return true;
    }

    return this.currentSubscription.category === plan.category &&
      this.currentSubscription.isAgency === plan.isAgency &&
      this.currentSubscription.plan.periodNumber === plan.plan.periodNumber;
  }

  private processSecondaryFeatures(): void {
    const countPipe = new CountPipe();
    const sizePipe = new SizePipe();
    this.secondaryFeatures = SecondaryFeatures;
    this.secondaryFeatures = this.secondaryFeatures.map((planGroup: any) => {
      const planType = Object.keys(planGroup)[0];
      const subscription = this.subscriptions.find(sub => sub.category === planType);

      if (!subscription) return planGroup;

      const plan = subscription;
      const features = planGroup[planType].map((feature: any) => {
        let title = feature.title;

        if (title.includes('%visits%')) {
          const visits = plan.plan.shortFeatures?.visits ||
            '<b>' + countPipe.transform(plan.plan.hostingService?.hosting_visits?.parameter_value) + '</b>' ||
            'not-found';
          title = title.replace('%visits%', visits);
        }

        if (title.includes('%storage%')) {
          const storage = plan.plan.shortFeatures?.storage ||
            '<b>' + sizePipe.transform(plan.plan.hostingService?.hosting_storage?.parameter_value * 1024 * 1024) + '</b>';
          title = title.replace('%storage%', storage);
        }

        if (title.includes('%cores%')) {
          const cores = '<b>' + plan.plan.dedicatedVMInfo?.core?.replace(' Core', '') + '</b>';
          title = title.replace('%cores%', cores);
        }

        if (title.includes('%ram%')) {
          const ram = '<b>' + plan.plan.dedicatedVMInfo?.ram + '</b>';
          title = title.replace('%ram%', ram);
        }

        return {
          ...feature,
          title
        };
      });

      return {
        [planType]: features
      };
    });
    console.log(this.secondaryFeatures);

  }

  private processAddOnsFeatures(): void {
    const countPipe = new CountPipe();
    const sizePipe = new SizePipe();

    const subscription = this.subscriptions.find(sub => sub?.plan?.periodNumber === this.periodSwitch);

    if (!subscription?.plan?.services) {
      return;
    }

    const services = subscription.plan.services;

    this.addOnsFeatures = this.addOnsFeatures.map((feature: any) => {
      if (!feature.originalTitle) {
        feature.originalTitle = feature.title;
        feature.originalPrice = feature.price;
        feature.originalDescription = feature.description;
      }

      let title = feature.originalTitle;
      let price = feature.originalPrice;
      let description = feature.originalDescription;

      if (price.includes('%addition_website_price%')) {
        price = price.replace('%addition_website_price%', services.hosting.domain_count.parameter_price / this.periodSwitch);
      }
      if (price.includes('%additional_cdn_price%')) {
        price = price.replace('%additional_cdn_price%', services.cloudflare_cdn.cdn_count.parameter_price / this.periodSwitch);
      }
      if (price.includes('%extra_visits_price%')) {
        price = price.replace('%extra_visits_price%', services.hosting.hosting_visits.parameter_price);
      }
      if (price.includes('%extra_bandwidth_price%')) {
        price = price.replace('%extra_bandwidth_price%', services.cloudflare_cdn.cdn_bandwidth.parameter_price);
      }
      if (price.includes('%extra_storage_price%')) {
        price = price.replace('%extra_storage_price%', services.hosting.hosting_storage.parameter_price);
      }

      if (description.includes('%additional_visits%')) {
        const visits = countPipe.transform(services.hosting.hosting_additional_visits.parameter_value);
        description = description.replace('%additional_visits%', visits);
      }
      if (description.includes('%additional_storage%')) {
        const storage = sizePipe.transform(services.hosting.hosting_additional_storage.parameter_value * 1024 * 1024);
        description = description.replace('%additional_storage%', storage);
      }
      if (description.includes('%additional_generations%')) {
        description = description.replace('%additional_generations%',
          services.ai_builder.regeneration_additional_count.parameter_value);
      }
      if (description.includes('%additional_bandwidth%')) {
        const bandwidth = sizePipe.transform(services.cloudflare_cdn.cdn_additional_bandwidth.parameter_value * 1024 * 1024);
        description = description.replace('%additional_bandwidth%', bandwidth);
      }

      if (title.includes('%extra_visits%')) {
        const visits = countPipe.transform(services.hosting.hosting_visits.base_value);
        title = title.replace('%extra_visits%', visits);
      }
      if (title.includes('%extra_bandwidth%')) {
        const bandwidth = sizePipe.transform(services.cloudflare_cdn.cdn_bandwidth.base_value * 1024 * 1024);
        title = title.replace('%extra_bandwidth%', bandwidth);
      }
      if (title.includes('%extra_storage%')) {
        const storage = sizePipe.transform(services.hosting.hosting_storage.base_value * 1024 * 1024);
        title = title.replace('%extra_storage%', storage);
      }

      return {
        ...feature,
        title,
        price,
        description
      };
    });
  }

  private updateEnterpriseSubscription(): void {
    this._sendEvent();

    if (!this.userHostingSubscriptions || !this.userHostingSubscriptions.length) {
      return;
    }

    const defaultWebsiteCount = '100';
    const defaultZone = 'Council Bluffs, Iowa, USA';

    const selectedWebsiteCount = this.selectedCount || defaultWebsiteCount;
    const selectedZone = this.selectedLocation || defaultZone;

    this.upgradeableEnterpriseSubscription = this.getMatchingEnterpriseSubscription(
      this.userHostingSubscriptions,
      selectedWebsiteCount,
      selectedZone,
      this.periodSwitch
    );

    if (!this.upgradeableEnterpriseSubscription) {
      this.upgradeableEnterpriseSubscription = this.getMatchingEnterpriseSubscription(
        this.userHostingSubscriptions,
        defaultWebsiteCount,
        defaultZone,
        this.periodSwitch
      );
    }

    if (this.upgradeableEnterpriseSubscription && this.subscriptions && this.subscriptions.length >= 3) {
      this.subscriptions[2] = this.upgradeableEnterpriseSubscription;
    }

    this.processSecondaryFeatures();
  }

  private getMatchingEnterpriseSubscription(
    subscriptions: UserSubscription[],
    selectedWebsiteCount: string,
    selectedZone: string,
    periodSwitchValue: number
  ): UserSubscription | null {
    const matchingSubscriptions = subscriptions.filter((userSubscription: UserSubscription): boolean => {
      return userSubscription &&
        userSubscription.type === UserSubscriptionCategory.DedicatedVM &&
        userSubscription.plan &&
        userSubscription.category === UserSubscriptionCategory.ENTERPRISE &&
        userSubscription.plan.periodNumber === periodSwitchValue;
    });

    const matchingSubscription = matchingSubscriptions.find((userSubscription: UserSubscription) => {
      const coreCountMatch = userSubscription.plan.title.match(/e2-standard-(\d+)/);
      if (!coreCountMatch) {
        return false;
      }

      const coreCount = parseInt(coreCountMatch[1], 10);

      const isMatchingPlan = (
        (selectedWebsiteCount === '100' && coreCount === 4) ||
        (selectedWebsiteCount === '400' && coreCount === 8) ||
        (selectedWebsiteCount === '1K' && coreCount === 16)
      );

      const isMatchingZone = userSubscription?.plans[selectedZone];

      if (isMatchingPlan && isMatchingZone) {
        userSubscription.plan = userSubscription.plans[selectedZone];
        return true;
      }

      return false;
    });

    return matchingSubscription ? matchingSubscription : null;
  }

  private _applyCoupon(subscriptionId, coupon): void {
    this._authService
      .applyCoupon(subscriptionId, coupon)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response) => {
        if (response.success) {
          this.applyCouponForPlatform = true;
          this.hasFreeDays =
            response.data.free_days_before_payment &&
            response.data.free_days_before_payment !== 0;
        }
      });
  }

  public switchToAnnual(): void {
    this._dialogService
      .addDialog(SwitchAnnualDialogComponent, {
        userSubscription: this.currentSubscription,
        annualPrice: this.annualPrice
      });
  }

}
